export default "__VITE_ASSET__DzYUFnJA__"